// src/api/keys.js
export const queryKeys = {
  services: (lang) => ['services', lang],
  service: (slug, lang) => ['service', slug, lang],
  projects: (page, perPage, lang) => ['projects', page, perPage, lang],
  project: (slug, lang) => ['project', slug, lang],
  skillCategories: (lang) => ['skill-categories', lang],
  experiences: (lang) => ['experiences', lang],
  educations: (lang) => ['educations', lang],
  testimonials: (lang) => ['testimonials', lang],
};